import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, OnDestroy, AfterViewInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { BarcodeDialog } from './barcode.dialog.component';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslateService } from '@services/translate.service';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { environment, MinSlipAmount } from '@environments/environment';
import { Subscription, interval, Subject, Observable } from 'rxjs';
import { GroupByEventName } from '@pipes/groupbyeventname.pipe';
import { MatDialog } from '@angular/material/dialog';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { Location } from '@angular/common';
import { pushToDataLayer } from '@helpers/gtm.util';
import { DataService } from '@services/data.service';
import { QRDialog } from './qr.dialog.component';
import { BoostInfoModal } from './boost-info-modal';
import { FreeBetInfoModal } from './freebet-info-modal';
import { BetsAcceptedModal } from './bets-accepted-modal';

declare let gtag;
declare let betaluxBr;
@Component({
  selector: 'current-slip-core',
  templateUrl: '../sharedTemplates/current-slip.core.html',
})
export class CurrentSlipCore implements OnInit, OnDestroy, AfterViewInit {
  isQuickAmount: boolean = environment.isQuickAmount;
  IsRegisterActive = true;

  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    public _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,
    private _router: Router,
    public _DataHelper: DataHelper,
    private _DataService: DataService,
    public dialog: MatDialog,
    private _location: Location
  ) {
    this.IsRegisterActive = environment.IsRegisterActive;
    this.cancel = this.state.pipe(
      filter(v => v === 'cancel'),
      tap(v => {
        this.holdTime.emit(0);
        this.holdSeconds = 0;
        this.progressValue = 0;
      })
    );
    // IOS 15 için Kontrol yapılıyor. Safari de IOS 15 te Submit Bet in üstünde siyah bir bar çıkıyor.
    const platform = navigator.platform;

    function iOSversion() {
      if (platform == 'iphone' || platform == 'Iphone') {
        const v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || (0 as any), 10)];
      } else {
        return [0];
      }
    }

    const ver = iOSversion();

    if (ver[0] >= 15) {
      this.ios15 = true;
    } else {
      this.ios15 = false;
    }

    this._DataService.setDataGetter('getCurrentSlipAmount', 10);
    this._DataService.setDataGetter('refreshCurrentSlip', 10);
  }

  holdSeconds = 0;
  progressValue = 0;
  accountLockIsDisabled = false;
  today = new Date();

  currentSlipList = [];
  slipsList = [];
  //
  public BettingSlip_Countdown = 5;
  private timer;
  public timer_subscription: Subscription;
  stakePerBet = 0;
  //
  systemItems = [];
  totalStakeKeyboard = '';
  tax = '';

  windowsH = 0;
  error_oddrefresherror = false;

  isMobileView = false;

  @Output() closeInformerModal: EventEmitter<any> = new EventEmitter();

  @ViewChild('focusElem1', { read: ElementRef })
  focusElem1: ElementRef;
  @ViewChild('focusElem2', { read: ElementRef })
  focusElem2: ElementRef;
  @ViewChild('focusElem3', { read: ElementRef })
  focusElem3: ElementRef;

  isWidgetInitialized = false;
  isWidgetInitializedM = false;
  isBalanceFormatShow = true;
  removeAllStep = 1;
  @ViewChild('brWidget')
  set childComponent(element: any) {
    if (environment.isActiveBRSmallWidget !== true) {
      return;
    }

    if (this.isMobileView) {
      return;
    }

    if (element && betaluxBr) {
      if (!this.isWidgetInitialized) {
        if (this.isWidgetInitializedM === true) {
          console.log('remove betrecommendM');
          betaluxBr.remove('betrecommend', 'widgetContainer');
        }
        const selectedLang = this._LocalizationService.LANGCODE;
        betaluxBr.init('betrecommend', 'widgetContainer', {
          apiKey: environment.bRSmallWidgetApiKey,
          language: selectedLang,
        });
        betaluxBr.get('betrecommend').setMarkets(this._DataHelper.currentSlipData.map(x => parseInt(x.OddId1, 10)));
        const theme = this._UiHelper.getTheme() === 'theme-dark' ? 'dark' : 'light';
        betaluxBr.get('betrecommend').setThemeMode(theme);
        betaluxBr.get('betrecommend').setLanguage(selectedLang);
        this.isWidgetInitialized = true;

        betaluxBr.offAll('betrecommend', 'addMarketToSlip');
        betaluxBr.on('betrecommend', 'addMarketToSlip', this.addMarketToSlip.bind(this));
      }
    } else {
      // betaluxBr.remove('betrecommend', 'widgetContainer');
      console.log('remove betrecommend');
      if (betaluxBr) {
        betaluxBr.offAll('betrecommend', 'addMarketToSlip');
      }
      this.isWidgetInitialized = false;
    }
  }

  @ViewChild('brWidgetM')
  set childComponentM(element: any) {
    if (environment.isActiveBRSmallWidget !== true) {
      return;
    }
    if (!this.isMobileView) {
      return;
    }

    if (element && betaluxBr) {
      if (!this.isWidgetInitializedM) {
        if (this.isWidgetInitialized === true) {
          console.log('remove betrecommend');
          betaluxBr.remove('betrecommend', 'widgetContainer');
        }
        const selectedLang = this._LocalizationService.LANGCODE;
        betaluxBr.init('betrecommend', 'widgetContainerM', {
          apiKey: environment.bRSmallWidgetApiKey,
          language: selectedLang,
        });
        betaluxBr.get('betrecommend').setMarkets(this._DataHelper.currentSlipData.map(x => parseInt(x.OddId1, 10)));
        const theme = this._UiHelper.getTheme() === 'theme-dark' ? 'dark' : 'light';
        betaluxBr.get('betrecommend').setThemeMode(theme);
        betaluxBr.get('betrecommend').setLanguage(selectedLang);
        this.isWidgetInitializedM = true;

        // todo cleaner
        betaluxBr.offAll('betrecommend', 'addMarketToSlip');
        betaluxBr.on('betrecommend', 'addMarketToSlip', data => {
          this.addMarketToSlip(data);
        });
      }
    } else {
      console.log('remove betrecommend');
      if (betaluxBr) {
        betaluxBr.offAll('betrecommend', 'addMarketToSlip');
      }
      this.isWidgetInitializedM = false;
    }
  }
  @Output() holdTime: EventEmitter<number> = new EventEmitter<number>();
  state: Subject<string> = new Subject<string>();
  cancel: Observable<string>;
  ios15 = false;

  private subscriptionsToStopOnDestroy: Subscription[] = [];
  lastSlipLength = 0;

  keyboardIsOpen = false;

  stakeString = '';

  topLeaguesData: Array<ITopLeagues> = [];
  selectedLeagueData = [];
  mainData = [];
  _dayFilter = 300;
  openedPanelId;

  oldCurrenSlipDataLength = 0;

  @HostListener('window:resize', ['$event'])
  @HostListener('touchend', ['$event'])
  @HostListener('touchstart', ['$event'])
  onResize(event) {
    this._UiHelper.setResolution(window.innerWidth, window.innerHeight);
  }

  @HostListener('mouseup', ['$event'])
  @HostListener('mouseleave', ['$event'])
  onExit() {
    this.state.next('cancel');
  }

  @HostListener('mousedown', ['$event'])
  onHold(e) {
    const target = e.target || e.srcElement || e.currentTarget;
    const idAttr = target.attributes.id;
    if (idAttr == undefined) {
      return '';
    }

    const value = idAttr.nodeValue;
    if (value != 'accountLockButton24v2') {
      return '';
    }

    this.state.next('start');

    const n = 100;
    interval(n)
      .pipe(
        takeUntil(this.cancel),
        tap(v => {
          const result = v * n;
          this.holdSeconds = result / 1000;
          this.progressValue = (this.holdSeconds / 3) * 100;
          if (result == 3000) {
            this.state.next('cancel');
            this._ApiService.accountLock24().then(result => {
              if (result.code == '') {
                return 'error|System Error';
              } else {
                if (result.code == 'error') {
                  this._UiHelper.errorSnackBar(result.message, '');
                } else if (result.code == 'errorcode') {
                  const t_message = this._TranslateService.instant(result.message);
                  this._UiHelper.errorSnackBar(t_message, '');
                } else if (result.code == 'success') {
                  this._UiHelper.successSnackBar(result.message, '');
                  this.holdSeconds = 0;
                  this.progressValue = 0;
                  this.accountLockIsDisabled = true;
                  this.signOut();
                }
              }
            });
          }

          this.holdTime.emit(result);
        })
      )
      .subscribe();
  }
  @HostListener('touchstart', ['$event'])
  onHold2(e) {
    const target = e.target || e.srcElement || e.currentTarget;
    const idAttr = target.attributes.id;
    if (idAttr == undefined) {
      return '';
    }

    const value = idAttr.nodeValue;
    if (value != 'accountLockButton24v2') {
      return '';
    }

    this.state.next('start');

    const n = 100;
    interval(n)
      .pipe(
        takeUntil(this.cancel),
        tap(v => {
          const result = v * n;
          this.holdSeconds = result / 1000;
          this.progressValue = (this.holdSeconds / 3) * 100;
          if (result == 3000) {
            this.state.next('cancel');
            this._ApiService.accountLock24().then(result => {
              if (result.code == '') {
                return 'error|System Error';
              } else {
                if (result.code == 'error') {
                  this._UiHelper.errorSnackBar(result.message, '');
                } else if (result.code == 'errorcode') {
                  const t_message = this._TranslateService.instant(result.message);
                  this._UiHelper.errorSnackBar(t_message, '');
                } else if (result.code == 'success') {
                  this._UiHelper.successSnackBar(result.message, '');
                  this.holdSeconds = 0;
                  this.progressValue = 0;
                  this.accountLockIsDisabled = true;
                  this.signOut();
                }
              }
            });
          }

          this.holdTime.emit(result);
        })
      )
      .subscribe();
  }
  getFreebetBonusInfo() {
    this._ApiService
      .getFreebetBonusInfo()
      .then()
      .catch(err => console.log('freebet', err));
  }
  getBoostBonusInfo() {
    this._ApiService
      .getBoostBonusInfo()
      .then()
      .catch(err => console.log('freebet', err));
  }

  signOut() {
    this._ApiService
      .signOut()
      .then(result => {
        this._UserHelper.userLogOut();

        this.refreshAPP();
      })
      .catch(err => console.log('idle.dialog', err));
  }
  refreshAPP() {
    window.location.href = '/home';
  }
  isSystemDropdownOpen = false;
  selectedText = '';

  toggleSystemDropdown() {
    this.isSystemDropdownOpen = !this.isSystemDropdownOpen;
    if (this.isSystemDropdownOpen) {
      this.changeBetSlipTab(2);
    } else if (this._DataHelper.currentSlipSystemSelection.length > 0) {
      return;
    } else {
      this.changeBetSlipTab(1);
    }
  }

  // Kullanıcı herhangi bir yere tıkladığında çağrılır
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;

    // Dropdown içindeyse kapanmaz
    if (targetElement.closest('.dropdown-container')) return;

    // Dropdown dışındaysa kapanır
    if (this.isSystemDropdownOpen) {
      this.toggleSystemDropdown();
    }
  }
  ngOnInit() {
    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.numberOfBetsListener.subscribe(x => {
        this._DataHelper.currentSlipData.length = x;
        if (this._DataHelper.currentSlipData.length < 2) {
          this._UiHelper.currentSlipTabSelected = 0;
        }
        if (this.lastSlipLength == 1 && this._DataHelper.currentSlipData.length > 1) {
          this._UiHelper.currentSlipTabSelected = 1;
        }
        if (this.lastSlipLength == 0 && this._DataHelper.currentSlipData.length > 1) {
          this._UiHelper.currentSlipTabSelected = 1;
        }
        this.lastSlipLength = this._DataHelper.currentSlipData.length;
      })
    );

    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.currentSlipDataListener.subscribe(x => {
        if (
          this._DataHelper.currentSlipData.length > 0 &&
          this.oldCurrenSlipDataLength !== this._DataHelper.currentSlipData.length &&
          this._UiHelper.currentSlipHeaderTabSelected === 1 &&
          this._UiHelper.currentSlipTabSelected === 2
        ) {
          this.getSystemItems();
          this.oldCurrenSlipDataLength = this._DataHelper.currentSlipData.length;
        }
        this._DataService.fireApiCall('getCurrentSlipAmount');
      })
    );

    if (this.windowsH === 0) {
      this.windowsH = this._UiHelper.windowsHeight;
    }
    this._UiHelper.windowResized.subscribe(x => {
      this.windowsH = x.h;
    });

    this.subscriptionsToStopOnDestroy.push(
      this._UserHelper.signInListener.subscribe(signin => {
        if (this._UserHelper.isSignedIn) {
          this._ApiService.getCashoutSlipsExternal(1).then();
        }
      })
    );

    this.subscriptionsToStopOnDestroy.push(this._DataHelper.numberOfCashoutListener.subscribe());

    this.getTopLeague();

    this._UiHelper.windowsWidth < 990 ? (this.isMobileView = true) : (this.isMobileView = false);
    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.windowResized.subscribe(x => {
        if (x.w <= 990) {
          this.isMobileView = true;
          this._UiHelper.currentSlipHeaderTabSelected = 1;
        } else {
          this.isMobileView = false;
        }
      })
    );

    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.currentSlipTabSelectedListener.subscribe(x => {
        if (this._UiHelper.currentSlipTabSelected === 2) {
          this.getSystemItems();
        }
      })
    );
  }

  ngAfterViewInit() {
    this.getCurrentSlip(this._ApiService.slipCurrents);
    this._UiHelper.currentSlipTabSelected = 1;
  }

  getCurrentSlip(x) {
    this._DataHelper.currentSlipData.length = x.length;
    this.currentSlipList = x;
    if (!this._UiHelper.checkboxAcceptOdds) {
      this.currentSlipList.forEach(item => {
        if (item.FirstOddValue1 !== undefined && item.FirstOddValue1 != item.OddValue1) {
          this._DataHelper.currentSlipInfo.oddIsChange = true;

          this._DataHelper.ChangeOddIsActive = true;
          this._UiHelper.placeBetIsActive = false;
        }
      });
    }

    this._changeDetection.detectChanges();

    // Live Odds Control
    const visibilityindex = this.currentSlipList.findIndex(v => {
      return v.Visibility == 'hidden';
    });

    if (visibilityindex > -1) {
      this.error_oddrefresherror = true;
    } else {
      this.error_oddrefresherror = false;
    }
  }

  openQRDialog(SuccessBarcode): void {
    const dialogRef = this.dialog.open(QRDialog, {
      width: '500px',
      disableClose: true,
      data: { barcode: SuccessBarcode, type: 'VorabTicket' },
    });
  }

  apiPlaceBetTemp(systemValues) {
    this._ApiService
      .placeBetTemp(this._DataHelper.currentSlipInfo.toPayNumeric, this._UiHelper.currentSlipTabSelected, systemValues)
      .then(data => {
        if (data.body == '') {
          return 'error|System Error';
        } else {
          if (data.body.split('|')[0] == 'error') {
            this._UiHelper.errorSnackBar(data.body.split('|')[1], '');
          } else if (data.body.split('|')[0] == 'errorcode') {
            const t_message = this._TranslateService.instant(data.body.split('|')[1], null);
            this._UiHelper.errorSnackBar(t_message, '');
          } else if (data.body.split('|')[0] == 'success') {
            const barcode = '500' + data.body.split('|')[2].toString();
            this.openQRDialog(barcode);
            this._ApiService.getSelectedOdds();
            this.closeInformerModal.emit(true);
          } else {
            this._UiHelper.errorSnackBar(data.body, '');
          }
        }
      })
      .finally(() => this._UiHelper.setLoadingDialog(false));
  }

  placeBetTemp() {
    this._UiHelper.setLoadingDialog(true);
    let systemValues = '';
    this.systemItems.forEach(cb => {
      if (cb.selected) {
        systemValues += '1,';
      } else {
        systemValues += '0,';
      }
    });
    if (systemValues != '') {
      systemValues = systemValues.substring(0, systemValues.length - 1);
    }

    if (this.timer_subscription != undefined) {
      this.timer_subscription.unsubscribe();
    }
    this.apiPlaceBetTemp(systemValues);
  }

  changeTotalStakeInput() {
    this.stakePerBet = this._DataHelper.currentSlipInfo.currentslip_totalStake / this._DataHelper.currentSlipData.length;

    this._DataService.fireApiCall('getCurrentSlipAmount');
  }

  removeOdd(oddId) {
    this._ApiService.currentSlipRemoveOdd(oddId);

    if (this._DataHelper.currentSlipData.length <= 1) {
      this._DataHelper.ChangeOddIsActive = true;
      this._UiHelper.placeBetIsActive = false;
      this.closeInformerModal.emit(true);
    }
  }
  isFreeBetAble(): boolean {
    return (
      !(this._UiHelper.currentSlipTabSelected === 0 && this._DataHelper.currentSlipData.length > 1) &&
      this._DataHelper.customerFreeBetBonusInfo?.MinOddValue <= this._DataHelper.currentSlipInfo.totalRate &&
      this._DataHelper.currentSlipInfo.totalRate * 1 <= this._DataHelper.customerFreeBetBonusInfo?.MaxOddValue &&
      this._DataHelper.customerFreeBetBonusInfo?.MinEventCount <= this._DataHelper.currentSlipInfo.numberOfBets * 1 &&
      this._UiHelper.currentSlipTabSelected !== 2 &&
      !this._DataHelper.currentSlipInfo.isMultiWaySystem
    );
  }
  removeAll(isStep = true) {
    if (!this.isMobileView) {
      this._DataHelper.currentSlipInfo.oddIsChange = false;
      this._DataHelper.ChangeOddIsActive = true;
      this._UiHelper.bookingCode = '';
      this._ApiService.clearCurrentSlip();
      this._ApiService.clearSlipSystem();

      this.closeInformerModal.emit(true);
      this.removeAllStep = 1;
    } else {
      if (this.removeAllStep === 1) {
        this.removeAllStep = 2;
        setTimeout(() => {
          if (this.removeAllStep === 2) {
            this.removeAllStep = 1;
          }
        }, 5000);
        return;
      } else if (this.removeAllStep === 2) {
        this._DataHelper.currentSlipInfo.oddIsChange = false;
        this._DataHelper.ChangeOddIsActive = true;
        this._UiHelper.bookingCode = '';
        this._ApiService.clearCurrentSlip();
        this._ApiService.clearSlipSystem();

        this.closeInformerModal.emit(true);
        this.removeAllStep = 1;
      }
    }
  }
  closeBottomSheet(): void {
    // todo Output
    this.closeInformerModal.emit(true);
  }

  placeBetActive(value) {
    this._DataHelper.ChangeOddIsActive = !value;

    this._UiHelper.placeBetIsActive = value;
  }

  placeBet() {
    this._DataHelper.currentSlipInfo.oddIsChange = false;
    window.scroll(0, 0);

    if (this._UserHelper.isSignedIn) {
      // this._UiHelper.setLoadingDialog(true);
      this._UiHelper.setLoadingTicketDialog(true);

      let systemValues = '';
      this.systemItems.forEach(cb => {
        if (cb.selected) {
          systemValues += '1,';
        } else {
          systemValues += '0,';
        }
      });
      if (systemValues != '') {
        systemValues = systemValues.substring(0, systemValues.length - 1);
      }

      if (this.timer_subscription != undefined) {
        this.timer_subscription.unsubscribe();
      }
      this.apiPlaceBet(systemValues);
    } else {
      const t_message = this._TranslateService.instant('errorcode5');
      this._UiHelper.errorSnackBar(t_message, '');
      this.closeBottomSheet();
      this._UiHelper.setRightMenu();
      setTimeout(x => {
        window.scroll(0, 0);
      }, 200);
    }
  }
  TotalAmount;
  apiPlaceBet(systemValues) {
    // Place Bet
    this._UiHelper.flagRefreshCurrentSlip = false;
    let tax: number = parseFloat(this._DataHelper.currentSlipInfo.tax);
    this.TotalAmount = this._DataHelper.currentSlipInfo.toPayNumeric;
    this._ApiService
      .placeBet(this.TotalAmount, this._UiHelper.currentSlipTabSelected, systemValues)
      .then(data => {
        this._UiHelper.setLoadingDialog(false);
        if (data.body == '') {
          this._UiHelper.flagRefreshCurrentSlip = true;
          return 'error|System Error';
        } else {
          if (data.body.split('|')[0] == 'error') {
            if (data.body.split('|')[1].trim() == 'error333' || data.body.split('|')[1].trim() == 'error333,') {
              this._UiHelper.flagRefreshCurrentSlip = true;
            } else if (data.body.split('|')[1].trim() == 'error334' || data.body.split('|')[1].trim() == 'error334,') {
              this._UiHelper.flagRefreshCurrentSlip = true;
            } else {
              this._UiHelper.flagRefreshCurrentSlip = true;
              this._UiHelper.errorSnackBar(data.body.split('|')[1], '');
            }
          } else if (data.body.split('|')[0] == 'errorcode') {
            const t_message = this._TranslateService.instant(data.body.split('|')[1], null);
            this._UiHelper.errorSnackBar(t_message, '');
            this._UiHelper.flagRefreshCurrentSlip = true;
          } else if (data.body.split('|')[0] == 'success') {
            pushToDataLayer({ event: 'betslip_complete', currency: 'euro', amount: this._DataHelper.currentSlipInfo.toPayNumeric });

            this._DataHelper.setBetAmounts();
            this._DataHelper.oldCouponList = JSON.parse(localStorage.getItem('currentslip'));
            this._ApiService.clearCurrentSlip();
            this._DataHelper.ChangeOddIsActive = true;
            this._UiHelper.placeBetIsActive = false;
            this._UiHelper.placedBetMessage = true;
            this._DataHelper.freebetBonusCheckBox = false;
            this._DataHelper.boostBonusCheckBox = false;
            this._DataHelper.currentSlipData.length = 0;
            const t_message = this._TranslateService.instant('successcode2');
            this._UiHelper.successSnackBar(t_message, '');

            this.dialog.open(BetsAcceptedModal, {
              minHeight: '350px',
              disableClose: true,
              data: {
                slipId: data.body.split('|')[2].trim().replace(',', ''),
              },
            });

            this._ApiService.getSelectedOdds();
            if (this._DataHelper.selectedWallet.IsFreeBetBonus) {
              this.getFreebetBonusInfo();
            } else if (this._DataHelper.selectedWallet.IsBoostBonus) {
              this.getBoostBonusInfo();
            }

            // rabbit mq'den aktığı için değişiklik hemen gözükmüyor bazen. Bu yüzden time out tanımlandı.
            setTimeout(() => this._DataService.fireApiCall('getSlipCashOutList', true, true), 1000);
            this.closeInformerModal.emit(true);

            // Bakiye güncellenmesi için.
            if (this._UserHelper.customerUser.CustomerId) {
              this._ApiService.getClient2().then();
            }
            this._ApiService.getSlips(new Date().getMonth(), new Date().getFullYear(), 1).then(x => {
              this.slipsList = [];
              if (x != undefined && x.length > 0) this.slipsList.push(x[0]);
            });
            if (environment.isMySlipLive) {
              this._DataHelper.mySlipMatchListApiCallListener.emit();
            }
          } else {
            pushToDataLayer({ event: 'betslip_failed' });
            const t_message_err = this._TranslateService.instant('errorcode3');
            this._UiHelper.errorSnackBar(t_message_err, '');
            this._UiHelper.flagRefreshCurrentSlip = true;
            throw new Error('Place Bet ' + data.body);
          }
        }
      })
      .catch(err => {
        console.error(err);
        this._UiHelper.setLoadingDialog(false);
      });
  }
  onBlurTotalStake(event): void {
    if (event.target.value === '' || event.target.value === '0') {
      event.target.value = MinSlipAmount;
      this._DataHelper.currentSlipInfo.currentslip_totalStake = MinSlipAmount;
      this._DataService.fireApiCall('getCurrentSlipAmount');
      this._DataService.fireApiCall('refreshCurrentSlip');
    }
  }

  changeTotalStake(event) {
    this._DataHelper.boostBonusCheckBox = false;
    const allowedCodes = [
      'Digit0',
      'Digit1',
      'Digit2',
      'Digit3',
      'Digit4',
      'Digit5',
      'Digit6',
      'Digit7',
      'Digit8',
      'Digit9',
      'Numpad0',
      'Numpad1',
      'Numpad2',
      'Numpad3',
      'Numpad4',
      'Numpad5',
      'Numpad6',
      'Numpad7',
      'Numpad8',
      'Numpad9',

      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
    ];

    const allowedKeys = ['.'];

    if (event && event.code && (allowedCodes.includes(event.code) || allowedKeys.includes(event.key))) {
      const newVal = event.target.value
        .split('.')
        .map((item, index) => (index === 1 ? `.${item.slice(0, 2)}` : item))
        .join('');
      event.target.value = newVal;
      this._DataHelper.currentSlipInfo.currentslip_totalStake = newVal;
    } else {
      event.target.value = this._DataHelper.currentSlipInfo.currentslip_totalStake;
    }
    if (event.target.value === '') {
      // If there is no value, set the default value
      // Buggy here, no code.
    }
    if (
      this._DataHelper.selectedWallet.IsBoostBonus &&
      !(
        this._DataHelper.currentSlipInfo.currentslip_totalStake <= this._DataHelper.customerBoostBonusInfo.MaxAmount &&
        this._DataHelper.customerBoostBonusInfo?.MinAmount <= this._DataHelper.currentSlipInfo.currentslip_totalStake
      )
    ) {
      this._DataHelper.boostBonusCheckBox = false;
    }

    this._DataService.fireApiCall('getCurrentSlipAmount');
    this._DataService.fireApiCall('refreshCurrentSlip');
  }

  getSystemItems() {
    this._DataService.fireApiCall('getSystemItems');
  }

  factorial(e) {
    if (e == 1 || e == 0) {
      return 1;
    } else {
      return e * this.factorial(e - 1);
    }
  }

  combination(r) {
    const n = this.systemItems.length;
    return this.factorial(n) / (this.factorial(n - r) * this.factorial(r));
  }
  changeAmount(event: any, index: number, combination: number) {
    const systemSelectKey = `${index + 1}_${combination}`;
    if (event.target.checked === true) {
      this._DataHelper.currentSlipSystemSelection = [...new Set([...this._DataHelper.currentSlipSystemSelection, systemSelectKey])];
      this._DataHelper.currentSlipInfo.isCheckIsSystem = true;
      this._UiHelper.currentSlipTabSelected == 2;
      this.selectedText = `${this._DataHelper.currentSlipSystemSelection.length} selected`;
    } else {
      this._DataHelper.currentSlipSystemSelection = this._DataHelper.currentSlipSystemSelection.filter(x => x !== systemSelectKey);
      if (this._DataHelper.currentSlipSystemSelection && this._DataHelper.currentSlipSystemSelection.length === 0) {
        this._DataHelper.currentSlipInfo.isCheckIsSystem = false;
        this._UiHelper.currentSlipTabSelected == 1;
        this.selectedText = '';
      }
    }

    this._DataService.fireApiCall('getCurrentSlipAmount', true);
  }

  changeSelectedSlipCurrent(e) {
    const enable = e.Enable;
    let bank = e.Banko;
    if (e.Banko) {
      bank = false;
    } else {
      bank = true;
    }

    if (e.eEvents != undefined && e.eEvents.length > 0) {
      e.eEvents.map(m => {
        this._ApiService.changeSelectedSlipCurrent(enable, bank, m.OddId1);
        return m;
      });
    }

    const oddId = e.OddId1;
    this._ApiService.changeSelectedSlipCurrent(enable, bank, oddId);
    this.changeTotalStakeInput();
    this._ApiService.getCurrentSlip();
    this.getSystemItems();
  }

  getLiveEvent(e) {
    if (this._DataHelper.liveData) {
      const match = this._DataHelper.liveData.find(m => m.EventId == e);
      // ////console.log("MACTH-----",match);
      return match;
    } else {
      this._DataHelper.currentSlipData.length = 0;
    }
  }

  reverse(e) {
    if (e.indexOf(':') > -1) {
      return e.split(':')[1] + ':' + e.split(':')[0];
    } else {
      return e;
    }
  }

  ngOnDestroy() {
    this._DataHelper.ChangeOddIsActive = true;
    this._UiHelper.placeBetIsActive = false;
    this._UiHelper.p1001SetBottomDialogState('close');
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
    this._UiHelper.placedBetMessage = false;
  }

  changeKeyboardState(value: boolean) {
    this.keyboardIsOpen = value;
    this._DataService.fireApiCall('getCurrentSlipAmount');
    this._DataHelper.boostBonusCheckBox = false;
  }

  changeBetSlipTab(tabId: 0 | 1 | 2) {
    this._DataHelper.freebetBonusCheckBox = false;
    this._DataHelper.boostBonusCheckBox = false;

    this._UiHelper.currentSlipTabSelected = tabId;
    this._UiHelper.setCurrentSlipTabSelected(tabId);
    this._DataService.fireApiCall('getCurrentSlipAmount');
  }

  slipHeaderChangeTab(tabId = 1) {
    this._UiHelper.setCurrentSlipHeaderTabSelected(tabId);
  }

  changeStakeInKeyboardp1001(e, option = '') {
    if (option == '') {
      this.stakeString += e;
      this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(this.stakeString);
      this._DataService.fireApiCall('getCurrentSlipAmount');
    } else if (option == 'backspace') {
      this.stakeString = this.stakeString.slice(0, -1);
      this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(this.stakeString);
    } else if (option == '+10') {
      this.stakeString = (Number(this.stakeString) + 10).toString();
      this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(this.stakeString);
      this._DataService.fireApiCall('getCurrentSlipAmount');
    } else if (option == '+50') {
      this.stakeString = (Number(this.stakeString) + 50).toString();
      this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(this.stakeString);
      this._DataService.fireApiCall('getCurrentSlipAmount');
    } else if (option == 'C') {
      this.stakeString = '0';
      this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(this.stakeString);
    }
    if (this._DataHelper.taxRate != 0) {
      this._DataHelper.currentSlipInfo.toPayNumeric = (this._DataHelper.currentSlipInfo.currentslip_totalStake * 100) / (100 + this._DataHelper.taxRate);
      this.tax = (this._DataHelper.currentSlipInfo.currentslip_totalStake - this._DataHelper.currentSlipInfo.toPayNumeric).toFixed(4);
    } else {
      this._DataHelper.currentSlipInfo.toPay = this._DataHelper.currentSlipInfo.currentslip_totalStake;
      this._DataHelper.currentSlipInfo.toPayNumeric = this._DataHelper.currentSlipInfo.toPay;
      this.tax = '';
    }
    if (this._UserHelper != undefined) {
      if (this._UserHelper.customerUser != undefined) {
        if (this._UserHelper.customerUser.Symbol == 'IQD' || this._UserHelper.customerUser.Symbol == 'IRR') {
          this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(e) * 1000;
        }
      }
    }
  }

  getTopLeague() {
    this._ApiService
      .getProcTournamentTopResult()
      .then((x: any) => {
        this.topLeaguesData = x;
      })
      .catch(err => console.log('current-slip.core', err));
  }

  getMatch(tournament) {
    this._UiHelper.p1001SetBottomDialogState('close');

    this.selectedLeagueData = [];
    const data = {
      TournamentName: tournament.TournamentName,
      TournamentId: tournament.TournamentId,
      CategoryId: tournament.CategoryId,
      CategoryName: tournament.TournamentName,
      SportId: 1,
      SportName: 'Fußball',
    };

    this.selectedLeagueData.push(data);

    this._DataHelper.setLeagueData(this.selectedLeagueData);

    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
  }

  CurrentSlipBack() {
    this._UiHelper.p1001SetBottomDialogState('close');
    this._UiHelper.bottomActiveItem = 2;
  }

  bookBetsReserveRoute() {
    this._router.navigate(['reserve']);
    this.CurrentSlipBack();
  }

  getNumber(val: any) {
    if (isNaN(val)) {
      return 0;
    }
    return +val;
  }
  openSettingsModal() {
    if (this.isMobileView) {
      this._UiHelper.settingsModalOpen = !this._UiHelper.settingsModalOpen;
    } else {
      this._UiHelper.openSettingsModal();
    }
  }

  trackByFnSystemCombinations(index, item) {
    return item.index + '_' + item.combination;
  }
  openInfoBoostModal(isOpenButton) {
    this.dialog.open(BoostInfoModal, {
      width: '300px',
      height: '480px',
      panelClass: 'boostModal',
      data: { isOpenButton: isOpenButton },
    });
  }
  openInfoFreebetModal() {
    this.dialog.open(FreeBetInfoModal, {
      width: '300px',
      height: '480px',
      panelClass: 'boostModal',
    });
  }
  addMarketToSlip(market) {
    const _outcome = market.marketOutcome;
    const _market = market.marketTypeText;

    const _betType = 0;

    // 07-03-2022 - SpecialBetValue Parantez kaldırıldı. Sebebi : İlk data da Parantezli geliyordu. Sonra refresh olunca gidiyordu parantez !
    // 07-03-2022 - Soccer için specialIsActive eklendi. Böylece Data ilk geldiğinde SpecialBetValue olmadığında Score gösterilmiş oldu !
    const newOdd = {
      Banko: false,
      BetType: _betType,
      Enable: true,
      EventDateLong: market.eventDate,
      EventName: market.eventName,
      MatchId: market.eventId,
      OddId1: parseInt(market.marketId),
      OddsType: _market,
      OddsTypeId: market.marketType,
      OddValue1: market.marketValue,
      OutCome: _outcome,
      ShortOddType: _market,
      // "SpecialBetValue": e['OddSpecialBetValue' + a.lineText] != undefined ? e['OddSpecialBetValue' + a.lineText] : '',
      SpecialBetValue: market.specialMarketValue,
      Visibility: '',
      HomeTeam: market.homeTeamName,
      AwayTeam: market.awayTeamName,
      WithBr: true,
    };

    this._ApiService.addOddDirectly(newOdd);
  }

  protected readonly environment = environment;
  setActiveQuickAmount(amount: number): void {
    this._DataHelper.currentSlipInfo.currentslip_totalStake = amount;
    this.changeStakeInKeyboardp1001(1, 'C');
    this.changeStakeInKeyboardp1001(amount, '');
  }
  changeTotalStakeBonus(isChecked: boolean): void {
    this._DataHelper.setFreeBet(isChecked);
    this._DataService.fireApiCall('getCurrentSlipAmount');
    this._DataService.fireApiCall('refreshCurrentSlip');
  }
  changeTotalRateBonus(isChecked: boolean): void {
    this._DataService.fireApiCall('getCurrentSlipAmount');
    this._DataService.fireApiCall('refreshCurrentSlip');
  }
  goEventDetail2(e, f, g, isLive) {
    this._DataHelper.selectedMatch = g;

    const ismobile = this._UiHelper.windowsWidth < 990 ? true : false;
    if (!isLive) {
      if (g == null) {
        if (ismobile) {
          const matchId = e == null ? f : e;
          this._UiHelper.setMatchDetailData(matchId, false);
        } else {
          this._router.navigate(['/eventdetail', e == null ? f : e]);
        }
      } else if (g.HasStreaming == null || g.HasStreaming == 'pre' || g.HasStreaming == false) {
        if (ismobile) {
          const matchId = e == null ? f : e;
          this._UiHelper.setMatchDetailData(matchId, false);
        } else {
          this._router.navigate(['/eventdetail', e == null ? f : e]);
        }
      } else {
        if (ismobile) {
          const matchId = e == null ? f : e;
          this._UiHelper.setMatchDetailData(matchId, true);
        } else {
          this._router.navigate(['/liveeventdetail', e == null ? f : e]);
        }
      }
    } else {
      if (ismobile) {
        const matchId = e == null ? f : e;
        this._UiHelper.setMatchDetailData(matchId, true);
      } else {
        this._router.navigate(['/liveeventdetail', e == null ? f : e]);
      }
    }

    this._UiHelper.p1001SetMatchDetailDialog('open');
  }
  protected readonly Array = Array;
}

interface ITopLeagues {
  CategoryId: number;
  ExtensionData: any;
  IsoName: string;
  TournamentId: number;
  TournamentName: string;
  TournamentSportEventCount: number;
}
